import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import { ProjectUser } from './shared'
import {
  getProjectUsers,
  GetProjectUsersArgs
} from './requests/get-project-users'
import { BugtrackerRequest } from '../../bugtrackers/api/shared'
import { buildApiPayloadBugtrackerCredentials } from '../../bugtrackers/api/build-api-payload-bugtracker-credentials'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'
import { UseQueryOptions } from 'react-query'

export interface UseProjectUsersQueryProps {
  organizationUuid: string
  bugtrackerRequest: BugtrackerRequest | null
  bugtrackerId?: number
  projectName?: string
  userSearch?: string
}

export interface ProjectUsersQueryResponse {
  users: ProjectUser[] | undefined
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseProjectUsersQuery = (
  props: UseProjectUsersQueryProps,
  reactQueryOptions?: UseQueryOptions<ProjectUser[]>
) => ProjectUsersQueryResponse

export const useProjectUsersQuery: UseProjectUsersQuery = (
  {
    organizationUuid,
    bugtrackerRequest,
    projectName,
    bugtrackerId,
    userSearch = ''
  },
  reactQueryOptions
) => {
  const {
    data: users,
    error,
    isError,
    isLoading
  } = useContrastQuery<GetProjectUsersArgs, ProjectUser[]>(
    [
      Query.INTEGRATIONS_PROJECT_USERS_JIRA,
      organizationUuid,
      projectName,
      userSearch,
      bugtrackerId
    ],
    getProjectUsers,
    {
      organizationUuid,
      bugtrackerRequest,
      projectName,
      userSearch,
      bugtrackerId
    },
    {
      enabled:
        !!buildApiPayloadBugtrackerCredentials(bugtrackerRequest) &&
        !!projectName,
      ...reactQueryOptions
    }
  )

  return {
    users,
    error,
    isError,
    isLoading
  }
}
